import type { Entry } from 'contentful';

import type { Banner } from '../../schema/spaces/ecommerce-petsmart';
import type { Card } from '../card-up';

type BannerCtaFields = NonNullable<Banner['fields']['cta']>['fields'];

export type MenuBanner = Omit<Banner['fields'], 'image' | 'cta'> & {
    sysType?: string;
    image: Banner['fields']['image']['fields'];
    cta?: Omit<BannerCtaFields, 'link'> & { link: BannerCtaFields['link']['fields'] };
};

export type MainMenuProps = {
    category: Entry[];
};

export type SpecialTypes = 'Shop By Brand' | 'Pet Services' | never;

export type CategoryTypes = Partial<{
    sysId: string;
    type?: 'text' | 'card' | 'image' | 'tabs' | 'my-store' | 'header';
    displayText?: string;
    link?: string;
    linkText?: string;
    imageUrl?: string;
    card?: Card;
    cards?: Card[];
    categories?: CategoryTypes[];
    specialType?: SpecialTypes;
    shopAllCategory?: boolean;
    rightMenuCard?: Card | MenuBanner;
    highlighted: boolean;
    wrapListItems: boolean;
    menuDropdownStyle?: boolean;
}>;

export type RecursiveMenuProps = {
    parentCategories: CategoryTypes[];
    specialType?: SpecialTypes;
    parentCategory?: string;
    path: string[];
    wrapListItems: boolean;
};

export type SubMenuProps = {
    mappedCategory: CategoryTypes;
    type: CategoryTypes['type'];
    specialType?: SpecialTypes;
    parentCategory?: string;
    path: string[];
    menuDropdownStyle?: boolean;
};

export type MenuCardProps = {
    card: Card;
    category?: string;
    onClick?: () => void;
};

export type TabbedMenuProps = {
    parentCategories: CategoryTypes[];
    parentCategory?: string;
    path: string[];
};

export type MarketingSectionProps = {
    rightMenuCard: CategoryTypes['rightMenuCard'];
    childCategories: CategoryTypes[];
    specialType?: SpecialTypes;
    path: string[];
};

export enum SPECIAL_TYPES {
    SHOP_BY_BRAND = 'Shop By Brand',
}
